export enum AppointmentType {
    BRANCH = 'BRANCH',
    CLIENT = 'CLIENT',
    PHONE = 'PHONE',
    VIDEO = 'VIDEO',
}
